const DEFAULT_SITE_URL = 'https://studio.centralfloridavocalarts.org';
const STALE_SITE_URLS = new Set([
  'https://cfva7648.builtwithrocket.new',
  'https://lessons.centralfloridavocalarts.org',
  'https://cfvastudio.netlify.app',
]);

export function normalizeSiteUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  const trimmed = url.trim().replace(/\/$/, '');
  if (!trimmed || !/^https?:\/\//i.test(trimmed)) {
    return null;
  }

  if (STALE_SITE_URLS.has(trimmed)) {
    return null;
  }

  return trimmed;
}

export function getSiteUrl(): string {
  if (typeof window !== 'undefined') {
    const windowOrigin = normalizeSiteUrl(window.location.origin);
    if (windowOrigin) {
      return windowOrigin;
    }
  }

  const envSiteUrl = normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL);
  if (envSiteUrl) {
    return envSiteUrl;
  }

  return DEFAULT_SITE_URL;
}

export function absoluteSiteUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getSiteUrl()}${normalizedPath}`;
}
